export default "__VITE_ASSET__BYMNl9Uv__"